import useLazyData from '@/hooks/useLazyData';
import Skeleton from './skeleton';
import LightningDealsMain from './light-deals';

const LightningDeals = props => {
  const { useSkeleton = false } = props;
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!useSkeleton) {
    return <LightningDealsMain skeleton={skeleton} {...props} />;
  }

  return (
    <div ref={viewRef} className="empty:hidden">
      {show || props?.data ? <LightningDealsMain skeleton={skeleton} {...props} /> : skeleton}
    </div>
  );
};

export default LightningDeals;
